/**
 * /admin/risk-review — Tenant-wide risk review queue (route shell).
 * Screen impl in `./risk-review-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/risk-review')({
  component: lazyRouteComponent(
    () => import('./risk-review-screen'),
    'AdminRiskReview',
  ),
});
